import { Paper } from "@mui/material";
import React from "react";
import Draggable from "react-draggable";

// Work around for overly strict react-draggable JSX typings.
const DraggableComponent = Draggable as unknown as React.ComponentType<
  React.PropsWithChildren<any>
>;

function DraggablePaperComponent(props: any) {
  return (
    <DraggableComponent
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </DraggableComponent>
  );
}

export default DraggablePaperComponent;
